<template>
    <div>
        <div class="content" style="display: none">
            <div class="assets">
                <img crossorigin="*" ref="images" v-for="img in images" v-bind:key="img" :data-src="img" data-load>
            </div>
        </div>
        <div ref="loader" class="loader">
<!--            <span ref="loader__animation" class="loader__animation">-->
<!--                <div ref="cube" class="cube">-->
<!--                    <div class="cube__face cube__face&#45;&#45;front"></div>-->
<!--                    <div class="cube__face cube__face&#45;&#45;back"></div>-->
<!--                    <div class="cube__face cube__face&#45;&#45;right"></div>-->
<!--                    <div class="cube__face cube__face&#45;&#45;left"></div>-->
<!--                    <div class="cube__face cube__face&#45;&#45;top"></div>-->
<!--                    <div class="cube__face cube__face&#45;&#45;bottom"></div>-->
<!--                </div>-->
<!--            </span>-->
<!--            <p class="loader__message">Preparing page...</p>-->
            <span class="loader__progress">
                <div ref="loaderBar" class="loader__progress-bar"></div>
                {{progressText}}
            </span>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "ImageLoader",
    props: ['images'],
    data: () => ({
        progressText: '',
        queue: {
            total: 0,
            length: 0,
            getProgress: function () {
                return (1 - (this.length / this.total)) * 100;
            },
        },
    }),
    mounted() {
        // this.content = document.querySelector('.content'),
        //     overlay: document.querySelector('.loader'),
        //     progressBar: document.querySelector('.loader__progress-bar'),
        this.load()
    },
    methods: {
        loadImage: function (element) {
            return new Promise((resolve, reject) => {
                element.addEventListener('load', () => {
                    this.next();
                    resolve(this);
                });
                element.addEventListener('error', () => {
                    element.remove();
                    this.next();
                    reject();
                });
                element.src = element.dataset.src;
            });
        },
        next: function () {
            this.queue.length -= 1;
            this.updateProgressBar();
        },
        updateProgressBar: function () {
            const prog = this.queue.getProgress()
            this.$refs.loaderBar.style.width = `${prog}%`;
            this.progressText = `${prog}%`
            this.$emit('progress', prog)
        },

        load: function () {
            let elements = Array.from(document.querySelectorAll('[data-load]'));
            this.queue.length += elements.length;
            this.queue.total += elements.length;

            const images = elements.map(element => {
                return this.loadImage(element).catch(ex => {
                    Vue.$log.error('could not load image', ex)
                });
            });
            Promise.all(images).then(() => {
                this.$emit('loaded', this.$refs.images)
            });
        },
    }
}
</script>

<style scoped>
@-webkit-keyframes spin {
    0% {
        transform: translateZ(-150em) rotateX(45deg) rotateZ(-45deg);
    }
    100% {
        transform: translateZ(-150em) rotateX(45deg) rotateZ(-225deg);
    }
}

@keyframes spin {
    0% {
        transform: translateZ(-150em) rotateX(45deg) rotateZ(-45deg);
    }
    100% {
        transform: translateZ(-150em) rotateX(45deg) rotateZ(-225deg);
    }
}

@-webkit-keyframes specular {
    0% {
        background-color: #3a3a3a;
    }
    100% {
        background-color: #444;
    }
}

@keyframes specular {
    0% {
        background-color: #3a3a3a;
    }
    100% {
        background-color: #444;
    }
}

body {
    font-family: sans-serif;
    color: #666;
}

img {
    vertical-align: middle;
    border: 0.5em solid white;
    margin: 0.5em;
    box-shadow: 0.25em 0.5em 1.5em rgba(0, 0, 0, 0.125);
}


.cube {
    -webkit-animation: spin 2s linear forwards infinite;
    animation: spin 2s linear forwards infinite;
    width: 100%;
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    transform: translateZ(-150em) rotateX(45deg) rotateZ(-45deg);
}

.cube .cube__face {
    position: absolute;
    width: 5em;
    height: 5em;
}

.cube .cube__face.cube__face--front {
    transform: rotateY(0deg) translateZ(2.5em);
    background-color: #333;
}

.cube .cube__face.cube__face--back {
    transform: rotateY(180deg) translateZ(2.5em);
    background-color: #333;
}

.cube .cube__face.cube__face--right {
    transform: rotateY(90deg) translateZ(2.5em);
    background-color: #3a3a3a;
    -webkit-animation: specular 1s linear 0.15s infinite alternate;
    animation: specular 1s linear 0.15s infinite alternate;
}

.cube .cube__face.cube__face--left {
    transform: rotateY(-90deg) translateZ(2.5em);
    background-color: #3a3a3a;
    -webkit-animation: specular 1s linear 0.15s infinite alternate;
    animation: specular 1s linear 0.15s infinite alternate;
}

.cube .cube__face.cube__face--top {
    transform: rotateX(90deg) translateZ(2.5em);
    background-color: #444;
    animation: specular 1s linear 0.15s infinite alternate-reverse;
}

.cube .cube__face.cube__face--bottom {
    transform: rotateX(-90deg) translateZ(2.5em);
    background-color: #444;
    animation: specular 1s linear 0.15s infinite alternate-reverse;
}

.loader {
    font-size: 1rem;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    position: fixed;
    /*top: 0;*/
    /*left: 0;*/
    /*width: 100vw;*/
    /*height: 100vh;*/
    background-color: #eee;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: progress;
    opacity: 1;
    transition: opacity 0.15s ease-in-out;
}

.loader .loader__animation {
    width: 5em;
    height: 5em;
    perspective: 100em;
}

.loader .loader__message {
    font-size: 0.65em;
    font-weight: 300;
    letter-spacing: 0.1em;
    margin-bottom: 1.5em;
    text-transform: uppercase;
}

.loader .loader__progress {
    position: relative;
    width: 8em;
    height: 0.5em;
    background-color: rgba(255, 255, 255, 0.5);
    overflow: hidden;
    border-radius: 0.2em;
}

.loader .loader__progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0;
    background-color: #666;
    transition: width 0.5s ease;
}

</style>
